import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Session } from '../../services/session.service';

@Component({
    selector: 'app-end-claimant-preview',
    template: `
            <app-dialog
                [title]="'Confirmation'"
                ariaLabel="Confirmation dialog"
                [confirmLabel]="'Continue'"
                [cancelLabel]="'Cancel'"
                [closeOnConfirm]="true"
                (confirmEvent)="stopEmulation()"
                [showHeader]="true"
              >

                {{'This will end your current preview of this account. Continue?' | translation: translationRequest}}

              
            </app-dialog>
  `,
    styles: [
        `
      .titleheading {
        color: #171c20 !important;
      }
      .close.mat-button {
        float: right;
        position: relative;
        color: #67707a;
      }
      .modal-body {
        height: 100px;
      }
      .pad-right-5 {
        padding-right: 2em;
      }
      .pad-top-2 {
        padding-top: 2em;
      }
      .closepnl {
        float: left;
        text-align: right;
      }
      .continuebtn {
        background-color: #007dbc !important;
        color: #fff;
      }
      .continuebtn:hover {
        background-color: #035e81 !important;
      }
      .closebtn {
        background-color: #ffffff !important;
        color: #3f464d;
        border: 1px solid #3f464d;
      }
      .closebtn:hover {
        background-color: #f1f4f7 !important;
      }
      .roundbtn {
        border-radius: 24px;
      }
    `,
    ],
    standalone: false
})
export class EndClaimantPreviewComponent {
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  
  title: string = 'Confirmation';
  callout: string = `This will end your current preview of this account. Continue?`;

  constructor(
    public dialogRef: MatDialogRef<EndClaimantPreviewComponent>,
    public session: Session,
    private router: Router
  ) {}

  closeModalPopUp() {
    this.session.ChangeClient(this.session.SelectedContNum);
    this.dialogRef.close();
  }

  async stopEmulation() {
    if (Number(this.session.SelectedUpdatedContNum) > -1) {
      const clientName =
        this.session.SelectedUpdatedClientName !== '-1'
          ? this.session.SelectedUpdatedClientName
          : this.session.SelectedClientName;
      this.session.SetSelectedClient(
        this.session.SelectedUpdatedContNum,
        clientName
      );
    }
    await this.session.stopEmulation('/');
  }
}
